import React from "react";
import ContentHeaderView from "../ContentHeaderView";
import "./styles.css";
/**
 * @function WidgetView
 * @param {STRING} widgetTitle - Injects text for the title of the widget.
 * @param {STRING} data-point - The data point that should be added
 * @param {React.Component} children - Allows us to inject other components inside the bottom portion, under the title. 
 * @returns {React.Component}
 * @example
 * <WidgetView widgetTitle="This is the title for a widget">
 *  <ContentHeaderView/>
 * </WidgetView>
 */
export default function WidgetView(props) {
  const text = props.text ?? "";
  const point = props["data-point"] ?props["data-point"] : props.dataPoint ?? "";

  return (
    <div className="widget-view">
      <ContentHeaderView text={text} data-point={ point } />
      {props.children}
    </div>
  );
}